import React from 'react';
import { FormField } from '../../FormField/FormField';
import { CopyRoutineButton } from '../../CopyRoutineButton/CopyRoutineButton';
import { ExerciseDay, Routine, RoutineExerciseHashMap } from '../../../types/Fisiofit/routine';
import { getDayExercisesWithPreloadValues } from '../utils/form';
import { RoutineFormFieldProps } from '../types';

type CopyRoutineFieldProps = Pick<RoutineFormFieldProps, 'form' | 'setFormFields'> & {
  currentRoutine: Routine | undefined;
  exercisePreloadValues: RoutineExerciseHashMap | undefined;
  isLoadingExercisePreloadValues: boolean;
};

export const CopyRoutineField = ({
  form,
  setFormFields,
  currentRoutine,
  exercisePreloadValues,
  isLoadingExercisePreloadValues,
}: CopyRoutineFieldProps) => {
  const handleCopyRoutine = (
    routine: Routine,
    options?: { specificDay?: { sourceDay: ExerciseDay; targetDayNumber: number } },
  ) => {
    if (options?.specificDay) {
      // Copiar un día específico
      const { sourceDay, targetDayNumber } = options.specificDay;

      // Buscar si ya existe un día con ese número
      const existingDayIndex = form.exerciseDays.findIndex((day) => day.dayNumber === targetDayNumber);

      if (existingDayIndex >= 0) {
        // Reemplazar día existente
        const updatedDays = [...form.exerciseDays];
        updatedDays[existingDayIndex] = {
          ...updatedDays[existingDayIndex],
          exercises: [...sourceDay.exercises],
          name: sourceDay.name,
        };

        setFormFields({
          exerciseDays: updatedDays,
        });
      } else {
        // Añadir nuevo día
        setFormFields({
          exerciseDays: [
            ...form.exerciseDays,
            {
              dayNumber: targetDayNumber,
              exercises: getDayExercisesWithPreloadValues(sourceDay.exercises, exercisePreloadValues),
              id: `day-${targetDayNumber}`,
              name: sourceDay.name || `Día ${targetDayNumber}`,
            },
          ],
        });
      }
    } else {
      // Copiar rutina completa (comportamiento original)
      setFormFields({
        exerciseDays: routine.exerciseDays.map((day) => ({
          ...day,
          id: `day-${day.dayNumber}`,
          exercises: getDayExercisesWithPreloadValues(day.exercises, exercisePreloadValues),
        })),
      });
    }
  };

  return (
    <FormField labelTitle='Copiar ejercicios de otra rutina' fullWidth>
      <div className='copy-routine'>
        <small>Puedes copiar todos los ejercicios de otra rutina y usarlos como base para crear esta rutina.</small>
        <CopyRoutineButton
          currentRoutine={currentRoutine}
          onSelectRoutine={handleCopyRoutine}
          currentDaysLength={form.exerciseDays.length ?? 0}
          loading={isLoadingExercisePreloadValues}
        />
      </div>
    </FormField>
  );
};
